import React,{Component} from 'react';
import Recipe from './Recipe';
import './RecipeList.css';
import PropTypes from 'prop-types';


class RecipeList extends Component{
    
static propTypes = {
    recipes:PropTypes.arrayOf(PropTypes.object).isRequired,
    onDelete: PropTypes.func.isRequired
} 

    render(){
        const {onDelete} = this.props;
        const recipes =  this.props.recipes.map((recipes,index) =>(
            <Recipe key={recipes.id}{...recipes} onDelete = {onDelete} />
        ));
        return(
            <div className = "recipe-list">
               {recipes}

            </div>
        );
    }
}

export default RecipeList;